import { useI18n as baseUseI18n } from 'vue-i18n';
import { unref } from 'vue';
import i18nMessagesEn from './en.json';
import i18nMessagesEs from './es.json';

import type { I18n, LocaleMessages, UseI18nOptions, VueI18n } from 'vue-i18n';

export const messages = {
    en: i18nMessagesEn,
    es: i18nMessagesEs
};

export function mergeMessages(i18n: I18n | VueI18n, messages: LocaleMessages<unknown>, allowScopes?: Array<string>) {
    let i18nGlobal: VueI18n = i18n as VueI18n;
    if ((i18n as I18n).global) {
        i18nGlobal = (i18n as I18n).global as VueI18n;
    }
    let scopedMessages: LocaleMessages<unknown> = {};
    if (allowScopes) {
        for (const scopeName of allowScopes) {
            if (messages[scopeName]) {
                scopedMessages[scopeName] = messages[scopeName];
            }
        }
    } else {
        scopedMessages = messages;
    }
    const locale = unref(i18nGlobal.locale);
    i18nGlobal.mergeLocaleMessage(locale, messages);
}

// Alias to fix type errors with the base injection.
export function useI18n(options?: UseI18nOptions): VueI18n {
    return baseUseI18n(options) as never;
}
